import { WarningFilled } from "@ant-design/icons"
import { Alert } from "antd"
import React from "react"

interface WarningAlertProps {
    message: React.ReactNode
    className?: string
}
const WarningAlert = ({ message, className }: WarningAlertProps) => <Alert className={className} message={message} type="warning" showIcon icon={<WarningFilled />} />

export default WarningAlert
